import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Mail } from "lucide-react";
 * // Use <Mail /> instead
 */
export const MailIcon = createSVGWrapper(
  <path
    fill="currentColor"
    d="M4 5C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V6C21 5.44772 20.5523 5 20 5H4ZM11.4 14.3L5 9.5V7L12 12.25L19 7V9.5L12.6 14.3C12.2444 14.5667 11.7556 14.5667 11.4 14.3Z"
    fillRule="evenodd"
    clipRule="evenodd"
  />
);
